import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'file-type-verifier'
})
export class FileTypeVerifierPipe implements PipeTransform {

  private isFileType(header: string): string {
    switch (header) {
      case '25504446':
        return 'application/pdf';
      case 'efbbbf56':
        return 'text/csv';
      case '89504e47':
        return 'image/png';
      case 'ffd8ffe0':
        return 'image/jpeg';
      case '504b34':
        return'application/x-zip-compressed';
      /* 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      */
      default:
        return 'unknown';
    }
  }

  private getFileHeader = (file: File): Promise<string> => {
    return new Promise(resolve => {
      const headerBytes = file.slice(0, 4);
      const fileReader = new FileReader();
      fileReader.onloadend = (e: ProgressEvent<FileReader>) => {
        const uInt8Array = new Uint8Array(e?.target?.result as ArrayBufferLike).subarray(0, 4);
        let magicNumbers = '';
        uInt8Array.forEach((item) => {
          magicNumbers += item.toString(16);
        });
        resolve(magicNumbers);
      };
      fileReader.readAsArrayBuffer(headerBytes);
    });
  }

  async transform(f: File) {
    const fileHeader = await this.getFileHeader(f);
    return f.type === this.isFileType(fileHeader);
  }

}
